module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('article', {
    staticClass: "blog_item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12"
  }, [_c('figure', [_c('a', {
    staticClass: "hover_effect h_blue h_link",
    attrs: {
      "href": "blog-post.html"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/assets/images/blog/latest_news1.jpg",
      "alt": "Image"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-12"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('h3', [_c('a', {
    attrs: {
      "href": "blog-post.html"
    }
  }, [_vm._v("Live your myth in Greece")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore...")]), _vm._v(" "), _c('a', {
    staticClass: "button btn_xs btn_blue",
    attrs: {
      "href": "blog-post.html"
    }
  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("JOHN DOE")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("AUGUST 13, 2015")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-comment-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("4 COMMENTS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-505316bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/Item.vue
// module id = 367
// module chunks = 0